import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  children,
  classes,
  products,
  schools,
} from '../../../../../../ZalamoLocalClient/src/canon/mocks';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
} from '@angular/forms';
import { ZalamoLocalClientService } from '@ui/zalamo-local-client/zalamo-local-client.service';
import { pluck } from 'rxjs';
import { MineOrganizationsGQL } from 'ZalamoLibrary/src/lib/core/organizations/organization-member/graphql';
import { environment } from '../../../environments/environment';
import { setCurrentOrganization } from 'ZalamoLibrary/src/lib/core/organizations/organization/redux/organization.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-cn',
  templateUrl: './cn.component.html',
  styleUrls: ['./cn.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CnComponent implements OnInit {
  schools = Object.entries(schools);
  classes = Object.entries(classes);
  products = Object.entries(products);
  children = Object.entries(children);
  currentSchool = '';
  currentClass = '';
  currentProduct = '';
  pickedChildren = new UntypedFormArray(
    this.children.map((v) => new UntypedFormControl(false)),
  );
  address = '';
  get childrenForm(): UntypedFormArray {
    return this.form.get('children') as UntypedFormArray;
  }

  form = this.fb.group({
    children: new UntypedFormArray(
      this.children.map((v) => new UntypedFormControl(false)),
    ),
    publicSessionOrganizationId: new UntypedFormControl(''),
    publicSessionOrganizationGroupId: new UntypedFormControl(''),
    productId: new UntypedFormControl(''),
  });
  mineOrganizations$ = this.mineOrganizations
    .fetch({})
    .pipe(pluck('data', 'mineOrganizations'));
  constructor(
    private fb: UntypedFormBuilder,
    private mineOrganizations: MineOrganizationsGQL,

    private localClientService: ZalamoLocalClientService,
    store: Store,
  ) {
    this.mineOrganizations$.subscribe((res) => {
      console.log(res, environment);

      store.dispatch(
        setCurrentOrganization({
          organizationId:
            (localStorage.lastZalamoOrganizationId &&
              res.find(
                (v) =>
                  v.organizationId === localStorage.lastZalamoOrganizationId,
              )?.organizationId) ??
            res[0].organizationId,
        }),
      );
    });
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(async (v) => {
      await this.localClientService.updateNextPhotoDetails({
        ...v,
        children: v.children
          .map((v, i) => (v ? this.children[i][0] : null))
          .filter((v) => v),
      });
    });
  }

  setSchool(school: string) {
    this.currentSchool = school;
    this.form.patchValue({
      publicSessionOrganizationId: school,
    });
  }
  setClass(school: string) {
    this.currentClass = school;
    this.form.patchValue({
      publicSessionOrganizationGroupId: school,
    });
  }
  setProduct(product: string) {
    this.currentProduct = product;
    this.form.patchValue({
      productId: product,
    });
  }
  async connect() {
    await this.localClientService.setCanonUrlAction(this.address);
  }
}
